module.exports = { id: "truck", url: "/build/app/img/symbols.svg#truck", viewBox: "", toString: function() { return this.url; } };